import { Location } from 'react-router-dom'

export function isObjectWithKey<T extends string>(
  given: unknown,
  key: T,
): given is Partial<Record<T, unknown>> {
  return typeof given === 'object' && given !== null && key in given
}

export function getPathname(location: Location): string | undefined {
  const { state } = location

  return isObjectWithKey(state, 'from') &&
    isObjectWithKey(state.from, 'pathname') &&
    typeof state.from.pathname === 'string'
    ? state.from.pathname
    : undefined
}
